import React from "react";
export default function Footer(){
    return (
        <footer id="footer">
            <h3>Developed by Achilles Drill © </h3>
        </footer>
    )
}